import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import {
  Loading,
  MultiSelect,
  Select,
  GalleryField,
  TextField,
  CkEditor,
  CheckBox,TextArea
} from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { useCore } from "store/core";
import { useWizard } from "store/wizard";
import Modal from "components/Modal";
import {
  generate_uuid,
  transformTranslateFromValues,
  transformTranslateServerValues,
} from "lib/helpers";
import VideoUploader from "lib/streamingUploader";

const PhysicalProductDetail = (props) => {
  const core = useCore();
  const wizard = useWizard();
  const [showAddPrice, setShowAddPrice] = useState(false);
  const [prices, setPrices] = useState([]);
  
 

  const _renderPrices = () => {
    return prices.map((item) => (
      <div className="grid grid-cols-4 gap-3">
        <h5>{item.currency === "USD" ? "دلار" : "تومان"}</h5>
        <h5 className="text-center">{item.amount}</h5>
        <h5 className="text-center">
          <button
            type="button"
            className={`btn btn-sm ${
              item.status ? "btn-success" : "btn-danger"
            }`}
            onClick={() => {
              setPrices([
                ...prices.filter((i) => i.uuid !== item.uuid),
                { ...item, status: !item.status },
              ]);
            }}
          >
            {item.status ? "فعال" : "غیرفعال"}
          </button>
        </h5>
        <div className="flex justify-center items-center">
          <button
            type="button"
            onClick={() => {
              setPrices(prices.filter((i) => i.uuid != item.uuid));
            }}
            className="btn btn-sm btn-danger"
          >
            حذف
          </button>
        </div>
      </div>
    ));
  };


  

  useEffect(() => {
    if (wizard.product &&
      wizard.product.prices) {
        setPrices(
          wizard.product.prices.map((i) => ({
            uuid: i.id,
            currency: i.currency,
            amount: i.amount,
            status: i.status,
          }))
        );
      }
    },[wizard.product]);

  
  if (wizard.load) {
    return (
      <>
        <div className="content">
          <div className="p-3 flex justify-center">
            <Loading />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <AddPrices
        close={() => setShowAddPrice(false)}
        show={showAddPrice}
        submit={(values) => {
          setPrices([...prices, values]);
        }}
      />

    
      <div className="font-medium text-base">اطلاعات تکمیلی</div>
      <Formik
        key="fromik_p_detail"
        initialValues={
          wizard.product && wizard.product.physical_detail
            ? {
                ...transformTranslateServerValues(
                  wizard.product.physical_detail
                ),
               
              }
            : {country_id:118 }
        }
        onSubmit={async (values, { setSubmitting }) => {
          values.prices=prices;
          await props.submitStep({
            ...transformTranslateFromValues(values),
            
          });
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, values,setFieldValue }) => (
          <Form>
              
            <div className="grid grid-cols-12 gap-4 gap-y-5 mt-5">
              <div className="grid grid-cols-12 gap-4 gap-y-3 col-span-7">
                <div className="intro-y col-span-12 sm:col-span-12">
                  <Field
                    label="عنوان :"
                    name="title"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <div className="intro-y mt-2">
                    <Field
                      label="عنوان انگلیسی :"
                      name="_en*title*text"
                      component={TextField}
                      validate={(value) => validationWrapper(value, required)}
                    />
                  </div>
                  <div className="intro-y flex gap-2 mt-2">
                    <Field
                      label="موجودی(انبار):"
                      name="inventory"
                      component={TextField}
                      
                    />
                    <Field
                      label="وزن (گرم):"
                      name="weight"
                      component={TextField}
                      
                    />
                    <Field
                      label="طول:"
                      name="length"
                      component={TextField}
                     
                    />
                    <Field
                      label="عرض:"
                      name="width"
                      component={TextField}
                      
                    />
                  </div>
                  
                </div>

                <div className="intro-y col-span-12 sm:col-span-6 lg:col-span-3">
                  <Field
                    label="ویژه"
                    name="featured"
                    component={CheckBox}
                    type="number"
                  />
                </div>
                </div>
               
                
              
                <div className="flex flex-col col-span-5">
                <div className="intro-y mt-3">
                  <div className="flex justify-between items-center">
                    <h3>قیمت :</h3>
                    <button
                      className="btn btn-sm btn-primary"
                      type="button"
                      onClick={() => setShowAddPrice(true)}
                    >
                      افزودن قیمت
                    </button>
                  </div>
                  </div>
                  <hr className="my-2" />
                  <div className="border rounded">
                  <div className="grid grid-cols-1 gap-4 mt-3">
                  <div className="grid grid-cols-4 gap-3">
                    <h5>واحد پولی</h5>
                    <h5 className="text-center">مقدار</h5>
                    <h5 className="text-center">وضعیت</h5>
                    <div className="flex justify-center items-center">
                      عملیات
                    </div>
                  </div>
                  {_renderPrices()}
                </div>
                  </div>
                </div>
                <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                <Field
                    label="تصویر"
                    name="media_id"
                    dataType="id"
                    component={GalleryField}
                />
                <Field
                    label="Image"
                    name="_en*media_id*media"
                    dataType="id"
                    component={GalleryField}
                />

                </div>
              <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                
                <div className="intro-y">
                  <Field
                    label="درباره محصول:"
                    name="full_desc"
                    component={CkEditor}
                  />
                </div>
               
                <div className="intro-y">
                  <Field
                    label="درباره محصول انگلیسی:"
                    name="_en*full_desc*text"
                    component={CkEditor}
                  />
                </div>
              </div>
              <div className="intro-y  col-span-12 sm:col-span-12 grid grid-cols-2 gap-x-2">
                <div className="intro-y">
                  <Field
                    label="توضیحات سئو(max 160 characters):"
                    name="seo_desc"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="توضیحات انگلیسی سئو(max 160 characters):"
                    name="_en*seo_desc*text"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی سئو(مانند:سریال,اکشن):"
                    name="seo_keywords"
                    component={TextArea}
                  />
                </div>
                <div className="intro-y">
                  <Field
                    label="کلمات کلیدی انگلیسی سئو(مانند:serie,action):"
                    name="_en*seo_keywords*text"
                    component={TextArea}
                  />
                </div>
              </div>
              <div className="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5">
                <button
                  className="btn btn-secondary w-24"
                  type="button"
                  onClick={() => wizard.dispatch(wizard.previous())}
                  disabled={isSubmitting}
                >
                  قبلی
                </button>
                <button
                  className="btn btn-primary w-24 mr-2"
                  disabled={isSubmitting}
                  type="submit"
                >
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  className="btn btn-secondary w-24 mr-2"
                  type="button"
                  onClick={() => {
                    wizard.dispatch(wizard.next());
                  }}
                  disabled={isSubmitting}
                >
                  بعدی
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PhysicalProductDetail;

export function AddPrices(props) {
  return (
    <Modal show={props.show} zIndex={1024} handleClose={props.close} title="افزودن قیمت">
      <Formik
        key="fromik_p_price"
        initialValues={{ uuid: generate_uuid() }}
        onSubmit={(values, { setSubmitting }) => {
          props.submit(values);
          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, handleSubmit }) => (
          <Form>
            <div className="modal-body gap-y-3">
              <div className="intro-x grid md:grid-cols-3 md:gap-3">
                <div className="">
                  <Field
                    placeholder="واحد پولی"
                    label="واحد پولی :"
                    name="currency"
                    component={Select}
                    options={[
                      { value: "IRR", label: "تومان" },
                      { value: "USD", label: "دلار" },
                    ]}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
                <div className="">
                  <Field
                    placeholder="مقدار"
                    label="مقدار :"
                    name="amount"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                </div>
                <div className="">
                  <Field label="وضعیت" name="status" component={CheckBox} />
                </div>
              </div>
            </div>
            <div className="modal-footer text-right">
              <button
                className="btn btn-primary w-20"
                type="button"
                onClick={handleSubmit}
                disabled={!!(isSubmitting || !dirty)}
              >
                {isSubmitting ? <Loading /> : "ذخیره"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-20 mr-1"
              >
                انصراف
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
